import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useState } from 'react'
import { useIntl } from '@/intl'
import styles from './Filters.module.css'
import { InWebsiteLanguageFilter } from './InWebsiteLanguageFilter'
import { PartyCompositionFilter } from './PartyCompositionFilter'
import { SortingSelect } from './SortingSelect'

export function Filters() {
  const [reviewsAmount, setReviewsAmount] = useState<number | null>(null)
  const intl = useIntl()

  return (
    <div className={styles.wrapper}>
      <div className={styles.partyCompositionFilterWrapper}>
        <PartyCompositionFilter setReviewsAmount={setReviewsAmount} />
      </div>
      <div className={styles.content}>
        {reviewsAmount && (
          <Typography variant="body-m-bold-tight" className={styles.amountText}>
            {intl.formatMessage({ id: 'reviews_amount_heading' }, { amount: reviewsAmount })}
          </Typography>
        )}
        <SortingSelect />
      </div>
      <InWebsiteLanguageFilter />
    </div>
  )
}
